import React from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";

import { SideMenu } from "../components/sideMenu.component";
import { LogoutBtn } from "../components/LogoutBtn.component";

export const MainPage = () => {

    let navigate = useNavigate();

    return (
        <div className='mainPage'>
            <nav className="navbar navbar-expand-lg navbar-light">
                <div className="container">
                    <Link className="logo" to={'/'}>
                        <img src='logo192.png' alt='logo' />
                    </Link>
                    <div className='headerRightBlock'>
                        <LogoutBtn navigate={navigate} />
                    </div>
                </div>
            </nav>
            <div className='contentWrapper'>
                <SideMenu />
                <div className='mainBlock'>
                    <Outlet />
                </div>
            </div>
        </div>
    );
};